import { Form, Select, Typography } from '@arco-design/web-react';
import FormModal from '../FormModal';
import type { Ticket } from '../../api/ticket';
import type { WorkflowTemplate } from '../../api/workflow';

export interface TicketSwitchWorkflowModalProps {
  /** 工单详情（标题展示工单号） */
  detail: Ticket | null;
  visible: boolean;
  /** 提交中（取消在途实例 → 用新模板重新发起审批） */
  saving: boolean;
  /** 所选新审核流程模板 id */
  templateId?: number;
  onTemplateChange: (v?: number) => void;
  /** 可选审核流程模板清单 */
  workflows: WorkflowTemplate[];
  onOk: () => void;
  onCancel: () => void;
}

/** v1.11 多流程转接：切换审核流程弹窗（取消在途实例 → 用新模板重新发起审批）。 */
export default function TicketSwitchWorkflowModal({
  detail,
  visible,
  saving,
  templateId,
  onTemplateChange,
  workflows,
  onOk,
  onCancel,
}: TicketSwitchWorkflowModalProps) {
  return (
    <FormModal
      title={`切换审核流程 #${detail?.id ?? ''}`}
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      confirmLoading={saving}
    >
      <Form layout="vertical">
        <Form.Item label="新审核流程" required>
          <Select
            placeholder={workflows.length ? '选择该工单改走哪个审核流程' : '暂无启用中的工单审核流程'}
            value={templateId}
            onChange={(v) => onTemplateChange(v as number)}
            options={workflows.map((w) => ({ label: `${w.name}（${w.code}）`, value: w.id }))}
          />
        </Form.Item>
      </Form>
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        将取消当前在途审批流程（实例取消 + 待办清除），改用所选模板重新发起审批，转接历史写入工单评论。
      </Typography.Text>
    </FormModal>
  );
}
